// External dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import get from 'lodash.get';
import { connect } from 'react-redux';
import FaLeanpub from 'react-icons/lib/fa/leanpub';
// Internal dependencies
import { states } from '../../values/enums';
import { getUserData } from '../../../../services/API';

// Components
import Loading from '../../../Global/Loading';
import PageStatus from '../../../Teacher/PageStatus';
import Error from '../../../Teacher/Error';
import DomainTabs from './DomainTabs';
import CarouselTabs from '../../../Global/CarouselTabs';
import { tooltipTypes, Tooltip } from '../../../Global/Tooltip';
import ResourceCard from './ResourceCard';

class DiagnosticContainer extends Component {

  componentDidMount () {
    this.props.initializeData();
  }

  getResourceCards(resourceCategories){
    if(!(resourceCategories && resourceCategories.length > 0)){
      return [];
    }
    let resourceCards = [(<div className="resourcesHeader" key="resourcesHeaderText">Resources & Examples<Tooltip type={tooltipTypes.resourcesAndExamples} />:</div>)];
    for(let i = 0; i < resourceCategories.length; i++){
      let resourceCardData = resourceCategories[i];
      if((resourceCardData.examples && resourceCardData.examples.length > 0) || (resourceCardData.resources && resourceCardData.resources.length > 0)){
        resourceCards.push(
          <ResourceCard title={resourceCardData.title} key={"resourceCard" + i}   examples={resourceCardData.examples} resources={resourceCardData.resources} />
        );
      }
    }
    return resourceCards.length > 1 ? resourceCards : [];
  }

  // Takes diagnose tab content JSON, and returns JSX
  getContent(tabData) {
    if(!tabData || !tabData.contents || !tabData.label) {
      return {};
    }
    let tabHasContents = false;

    let contents = tabData.contents || [];
    let carouselTabProps = [];
    for(let i = 0; i < contents.length; i++){
      let carouselTabData = contents[i];

      if(carouselTabData.fields && carouselTabData.fields.length){
        tabHasContents = true;

        let carouselTab = {};
        carouselTab.title = carouselTabData.name;
        carouselTab.detail = carouselTabData.fields;
        carouselTab.content = this.getResourceCards(carouselTabData.resources);
        carouselTabProps.push(carouselTab);
      }
    }

    let carouselTabs = (<CarouselTabs tabs={carouselTabProps} selectedTabIndex={carouselTabProps.length > 1 ? 1:0}/>);

    return { content: carouselTabs, tabHasContents };
  }

  /**
   * Create an array of skill domain tabs from props.report for rendering
   * @returns array or null
   */
  getTabs(){
    if(!this.props.report)
      return null;

    const skillDomains = Object.keys(this.props.report)
    const tabs = skillDomains.reduce((domainTabs, domain, i) => {
      const domainReport = this.props.report[domain]
      if(domainReport && domainReport.label && domainReport.contents){
        const { content, tabHasContents } = this.getContent(domainReport);
        domainTabs.push({
          tab: {
            label: domainReport.label,
            percentage: domainReport.score
          },
          content: tabHasContents ? content : false
        })
      }
      return domainTabs
    }, [])

    if(tabs.length) return tabs
    return null
  }

  getOtherResources() {
    return getUserData().texasResources ?
        <Link to={"/teacher/resources"} className="otherResourcesButtonLink">
          <FaLeanpub className="otherResourcesButtonIcon" size="20" />
          TPRI Resources
        </Link> : null;
  }

  render () {
    let tabs = this.getTabs();
    let diagnosticContents;

    if(get(this.props, 'reportStatus.type') === states.COMPLETE) {
      if(tabs) {
        const cutoffs = {
          okay: get(this.props.report, 'cutoffs.okay') || 25,
          good: get(this.props.report, 'cutoffs.good') || 75
        }
        diagnosticContents = <DomainTabs tabs={tabs} cutoffs={cutoffs}/>;
      } else {
        diagnosticContents =
          <div className="diagnosticPageStatusContainer"> 
            {this.getOtherResources()}
            <PageStatus
              isAggregateReport={false}
              viewText= "diagnostic"/>
          </div>;
      }
    } else if(get(this.props, 'reportStatus.type') === states.ERROR) {
      diagnosticContents = <Error />;
    } else {
      diagnosticContents = <Loading />;
    }

    return (
      <div className="reports-container diagnostic">
        {diagnosticContents}
      </div>
    )
  }
}

function mapStateToProps (state) {
  const { roster } = state.reports;
  return {
    selectedStudent: roster.ui && roster.ui.selections.student ? roster.ui.selections.student.label : "",
    selectedLocale: get(state, 'reports.teacher.selectedLocale', true),
    report: get(state, 'reports.diagnostic.report.data', null),
    reportStatus: get(state, 'reports.diagnostic.report.status', null),
  }
};

// TODO diagnostic propTypes
DiagnosticContainer.propTypes = {
  // describe me
  report: PropTypes.object,
}

export default connect(mapStateToProps)(DiagnosticContainer)
